import Vue from 'vue'
import { Skeleton, SkeletonItem, Carousel, CarouselItem, Pagination, Collapse, CollapseItem } from 'element-ui'

Vue.use(Skeleton);
Vue.use(SkeletonItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Pagination)
Vue.use(Collapse)
Vue.use(CollapseItem)
